export const isInsideIFrame = window === window.parent ? false : true;
